import { isActiveMembership } from "helpers/membership-helpers";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import ZipUpdater from "./address-zip-updater/zip-updater";
import AddressUpdater from "./address-zip-updater/address-updater";
import { useEffect } from "react";
import { changeFilters, refreshMembershipDepotIdCookie } from "actions/products-actions";
import { usePersistedFilters } from "../hoc/with-persisted-filters";
import ShippingAndReturns from "../pdp/shipping-and-returns";

// when adding shipping-and-return.jsx into this file - remember to update depotId
// as the original file doesn't do so

export default function AddressZipUpdater({ isGridProductDrawer, mode }) {
  const dispatch = useDispatch();
  const { writePreferences } = usePersistedFilters();
  const workingFilters = useSelector(state => state.workingFilters);
  const membershipState = useSelector(state => state.membershipState);
  const isProspect = !isActiveMembership(membershipState);
  const staticProduct = useSelector(state => state.staticProduct);
  const membershipStateLoading = useSelector(state => state.membershipStateLoading);

  // using this function we are updating the redux state's workingfilter with zip_code or/and
  // depotId and also update the local storage with the same values - to maintain consistent
  // behaviour across PDPs and grids
  const saveZipOrDepotWorkingFilters = newFilters => {
    const updatedFilters = {
      ...newFilters,
      ...workingFilters,
    };
    dispatch(changeFilters(updatedFilters));
    writePreferences(updatedFilters);
  };

  useEffect(() => {
    if (workingFilters?.zip_code) {
      dispatch(refreshMembershipDepotIdCookie(workingFilters.zip_code, saveZipOrDepotWorkingFilters));
    }
  }, [workingFilters?.zip_code]);

  if (mode === "buy") {
    return (
      <ShippingAndReturns className="mt-2 text-left" product={staticProduct} hasAddress={!!membershipState?.address} />
    );
  }

  if (membershipStateLoading !== false) {
    return;
  }

  if (isProspect) {
    return (
      <ZipUpdater isGridProductDrawer={isGridProductDrawer} saveZipToWorkingFilter={saveZipOrDepotWorkingFilters} />
    );
  }

  return <AddressUpdater saveZipToWorkingFilter={saveZipOrDepotWorkingFilters} />;
}

AddressZipUpdater.propTypes = {
  isGridProductDrawer: PropTypes.bool,
  mode: PropTypes.string,
};
